/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：615
 */

"use strict"

export { a }
export { s as b }
import * as /* [auto-meaningful-name] */Module_19 from /* 19 */"../19"
import * as /* [auto-meaningful-name] */Module_609 from /* 609 */"./609"
var o = Module_19.a({}, Module_609.a.Modal)
function a(e) {
  o = e ? Module_19.a(Module_19.a({}, o), e) : Module_19.a({}, Module_609.a.Modal)
}
function s() {
  return o
}
export default a
